import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {FilesizePipe} from './filesize.pipe'
import {KeysPipe} from './keys.pipe'
import {DatePipe} from './date.pipe'

@NgModule({
  imports: [CommonModule],
  declarations: [FilesizePipe, KeysPipe, DatePipe],
  exports: [FilesizePipe, KeysPipe, DatePipe],
})
export class PipeModule {}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/pipe/pipe.module.ts